import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Upload, Download, Database, ArrowUpToLine, FileUp, X, File } from "lucide-react";
import { downloadGedcom, uploadGedcom } from "../services/apiService";

export default function GedcomUploader() {
  const { register, handleSubmit, formState: { errors }, watch, setValue } = useForm();
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // מעקב אחר הקובץ שנבחר
  const selectedFile = watch("file")?.[0];

  const onSubmit = async (data) => {
    setLoading(true);
    setUploadProgress(0);

    // מדמה התקדמות העלאה
    const progressInterval = setInterval(() => {
      setUploadProgress(prev => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return 90;
        }
        return prev + 10;
      });
    }, 1200);
    try {
      console.log(data)
      await uploadGedcom(data);
      setUploadProgress(100);
      const fileName = data.file[0].name;
      console.log(data, fileName);
      setUploadedFileName(fileName);
      alert("הקובץ הועלה בהצלחה!");
    } catch (err) {
      alert("שגיאה בהעלאת הקובץ.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    if (!uploadedFileName) {
      alert("לא נמצא שם קובץ להורדה.");
      return;
    }
    try {
      await downloadGedcom(uploadedFileName);
    } catch (err) {
      alert("שגיאה בהורדת הקובץ.");
    }
  };

  // פונקציה להסרת הקובץ שנבחר
  const handleRemoveFile = () => {
    setValue("file", null);
  };

  return (
      <div className="bg-white rounded-xl p-6 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
        <h2 className="text-xl font-heebo font-bold text-[#937c5d] mb-6 flex items-center gap-2 border-b border-[#e6dfd4] pb-4">
          <Database className="w-6 h-6" />
          עיבוד קובץ GEDCOM
        </h2>

        <div className="max-w-2xl mx-auto space-y-8">
          <div className="bg-[#937c5d]/5 rounded-lg p-4">
            <p className="text-[#4a3f30] font-heebo leading-relaxed">
              העלה קובץ GEDCOM לעיבוד והוספת מזהים חסרים.
              המערכת תזהה רשומות ללא ID ותוסיף להן מזהה MongoDB חדש.
            </p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="relative">
              {loading && (
                  <div className="absolute inset-0 bg-black/5 rounded-lg flex items-center justify-center">
                    <div className="w-full max-w-md mx-4">
                      <div className="bg-gray-200 rounded-full h-2.5">
                        <div
                            className="bg-[#937c5d] h-2.5 rounded-full transition-all duration-300"
                            style={{ width: `${uploadProgress}%` }}
                        />
                      </div>
                      <div className="text-center mt-2 text-sm text-[#937c5d]">
                        {uploadProgress}%
                      </div>
                    </div>
                  </div>
              )}
              <label className={`flex flex-col items-center justify-center border-2 border-dashed 
              ${selectedFile ? 'border-[#937c5d]' : 'border-[#937c5d]/30'}
              rounded-lg p-8 cursor-pointer hover:border-[#937c5d] transition-colors
              ${selectedFile ? 'bg-[#937c5d]/5' : ''}`}>

                {selectedFile ? (
                    <div className="flex flex-col items-center gap-2">
                      <div className="flex items-center gap-2">
                        <File className="w-6 h-6 text-[#937c5d]" />
                        <span className="text-[#937c5d] font-heebo font-medium">
                      {selectedFile.name}
                    </span>
                      </div>
                      <span className="text-[#937c5d]/70 text-sm">
                    {(selectedFile.size / 1024).toFixed(1)} KB
                  </span>
                      <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            handleRemoveFile();
                          }}
                          className="mt-2 flex items-center gap-1 text-red-500 hover:text-red-600 transition-colors"
                      >
                        <X className="w-4 h-4" />
                        <span className="text-sm">הסר קובץ</span>
                      </button>
                    </div>
                ) : (
                    <>
                      <ArrowUpToLine className="w-8 h-8 text-[#937c5d] mb-2" />
                      <span className="text-[#937c5d] font-heebo">
                    {loading ? "מעלה..." : "גרור לכאן קובץ או לחץ לבחירה"}
                  </span>
                    </>
                )}

                <input
                    type="file"
                    accept=".ged"
                    {...register("file", {
                      required: "יש לבחור קובץ להעלאה",
                      validate: (value) => {
                        const file = value?.[0];
                        return file && file.name.toLowerCase().endsWith(".ged") || "יש לבחור קובץ עם סיומת .ged בלבד";
                      },
                    })}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
              </label>
              {errors.file && (
                  <p className="text-red-500 text-sm mt-2 text-center">{errors.file.message}</p>
              )}
            </div>

            <div className="flex justify-center gap-4">
              <button
                  type="submit"
                  disabled={loading || !selectedFile}
                  className={`px-6 py-2.5 font-heebo flex items-center gap-2 transition-colors focus:outline-none
                ${!selectedFile ? 'text-[#937c5d]/50 cursor-not-allowed' : 'text-[#937c5d] hover:text-[#4a3f30]'}`}
              >
                <FileUp className="w-5 h-5" />
                {loading ? "מעלה..." : "העלה את הקובץ"}
              </button>

              {uploadedFileName && (
                  <button
                      type="button"
                      onClick={handleDownload}
                      disabled={loading}
                      className="px-6 py-2.5 text-[#937c5d] hover:text-[#4a3f30] font-heebo
                       flex items-center gap-2 transition-colors focus:outline-none"
                  >
                    <Download className="w-5 h-5" />
                    {loading ? "מוריד..." : "הורד קובץ מעודכן"}
                  </button>
              )}
            </div>
          </form>

          {uploadedFileName && (
              <div className="text-center text-[#937c5d]/70 font-heebo">
                <span>קובץ נוכחי: </span>
                <span className="font-medium">{uploadedFileName}</span>
              </div>
          )}
        </div>
      </div>
  );
}